<app-widget [widget-meta]="this.data"
  class="widget-content">
  @if (cmsContent.data$ | async; as content) {
    <div>
      @if (content.length > 0) {
        @if (hasHtmlContent(content)) {
          @for (item of content; track item) {
            <div class="quick-link-item" (click)="linkClicked(item)">
              <h5>{{item.Title}}</h5>
              <p [innerHTML]="item.Content"></p><br>
            </div>
          }
        }
        @if (!hasHtmlContent(content)) {
          <ul class="forms">
            @for (item of content; track item) {
              <li class="form-item">
                <i class="{{item.IconClass}}">&nbsp;</i>
                <a href="{{item.Link}}" target="_blank" (click)="linkClicked(item)">{{item.Title}}</a>
              </li>
            }
          </ul>
        }
      }
      @if (content.length <= 0) {
        <div>
          <div class="row">
            <div class="col-md-12">
              <span class="detail">No {{title}}</span><br />
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
  }
  <loading-or-error #loadingOrError
    [loadingWrapper]="cmsContent"
    [errorMessage]="">
  </loading-or-error>
</app-widget>



